export enum AppMessageListType {
    TEMPLATE = 'template',
    APP_MESSAGE = 'app_message',
}
